export const PIPELINE_RUN_STATUS = {
    PENDING: 'pending',
    RUNNING: 'running',
    COMPLETED: 'completed',
    FAILED: 'failed',
};
export const PIPELINE_RUN_STATUS_VALUES = Object.values(PIPELINE_RUN_STATUS);
export const PIPELINE_SOURCE = {
    TIKTOK: 'tiktok',
    /** Тема введена модератором руками, без парсинга. */
    IDEA: 'idea',
};
export const PIPELINE_SOURCE_VALUES = Object.values(PIPELINE_SOURCE);
//# sourceMappingURL=pipeline.js.map